import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrowRight = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M7.91 12.87C8 12.97 8.13 13.02 8.26 13.02L8.27 13C8.4 13 8.52 12.95 8.62 12.85L13.5784 7.93754C13.6324 7.90185 13.6788 7.85586 13.715 7.80217L14.02 7.5L8.62 2.15C8.42 1.95 8.1 1.95 7.91 2.15C7.71 2.35 7.71 2.67 7.91 2.86L12.0968 7.02H2.5C2.22 7.02 2 7.24 2 7.52C2 7.8 2.22 8.02 2.5 8.02H12.0767L7.91 12.16C7.72 12.36 7.72 12.67 7.91 12.87Z' />
  </svg>
);
export default SvgArrowRight;
